<template>
  <div class="addAddress absolute">
    <div class="promoterHeader bg-color-red">
      <div class="headerCon acea-row row-between-wrapper">
        <div>
          <div class="name">当前可用积分</div>
          <div class="money">
            <span class="num">{{ pkSet.integral }}</span>
          </div>
        </div>
        <div class="iconfont icon-jinbi1"></div>
      </div>
    </div>
    <div class="list">
      <div class="item acea-row row-between-wrapper">
        <div class="name">对手</div>
        <!-- <input
          type="text"
          placeholder="请输入对手手机号或昵称"
          v-model="userPk.phone"
          required
        /> -->
        <el-autocomplete
          popper-class="my-autocomplete"
          v-model="userPk.phone"
          :fetch-suggestions="querySearch"
          placeholder="您可以选择或输入对手手机号"
          @select="handleSelect"
        >
          <i
            class="el-icon-edit el-input__icon"
            slot="suffix"
            @click="handleIconClick"
          >
          </i>
          <template slot-scope="{ item }">
            <div class="name">{{ item.value }}</div>
            <span class="addr">{{ item.nickname }}</span>
          </template>
        </el-autocomplete>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div class="name">选择pk月份</div>
        <div class="dp_form_right">
          <el-date-picker
            v-model="userPk.starttime"
            type="month"
            placeholder="选择月"
            value-format="yyyy-MM"
            :picker-options="pickerOptions0"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div class="name">筹码类型</div>
        <div class="dp_form_right">
          <el-radio-group v-model="userPk.chip_type" @change="ChipTypeChange">
            <el-radio :label="0">积分</el-radio>
            <el-radio :label="1">金额</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div class="name">筹码数量</div>
        <div class="dp_form_right">
          <el-select v-model="userPk.chip" placeholder="请选择">
            <el-option
              v-for="item in pkSet.chips"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div></div>
    <div class="keepBnt bg-color-red" @click="submit">发起PK</div>
  </div>
</template>
<script type="text/babel">
import { getUserPk, postPk, getPkSet, getUserPkUser } from "@api/user";
import { required, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
export default {
  components: {},
  data() {
    return {
      id: 0,
      userPk: {
        chip_type: 0,
        phone: "",
        uid: 0,
        starttime: "",
        endtime: "",
        chip: "",
      },
      restaurants: [],
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      pkSet: { integral: 0, jifenitem: [], jineitem: [], chips: [] },
    };
  },
  mounted: function() {
    let id = this.$route.params.id;
    this.id = id;
    document.title = !id ? "发起PK" : "修改PK";
    this.getPkSetInfo();
    this.getPk(this.id);
    this.loadAll();
  },
  methods: {
    ChipTypeChange: function(val) {
      let that = this;
      //console.log(val==0);
      that.userPk.chip = ""; //清空已选择
      if (val == 1) {
        that.pkSet.chips = that.pkSet.jifenitem;
      } else {
        that.pkSet.chips = that.pkSet.jineitem;
      }
    },
    getPkSetInfo: function() {
      //获取pk配置
      let that = this;
      getPkSet().then((res) => {
        that.$set(that, "pkSet", res.data);
        that.pkSet.chips = res.data.jifenitem;
      });
    },
    getPk: function() {
      if (!this.id) return false;
      let that = this;
      getUserPk(that.id).then((res) => {
        that.userPk = res.data;
        that.userPk.phone = res.data.phone;
        that.userPk.uid = res.data.uid;
        that.userPk.starttime = res.data.starttime;
        that.userPk.endtime = res.data.endtime;
        that.userPk.chip_type = res.data.chip_type;
        that.userPk.chip = res.data.chip;
      });
    },
    async submit() {
      let phone = this.userPk.phone,
        starttime = this.userPk.starttime,
        endtime = this.userPk.endtime,
        chip_type = String(this.userPk.chip_type),
        chip = this.userPk.chip;
      console.log(chip_type);
      try {
        await this.$validator({
          //await 先阻塞后边代码，等右侧执行完成后根据返回结果，决定是否执行后续代码，详情https://www.jianshu.com/p/b4fd76c61dc9
          phone: [
            required(required.message("请输入pk对象的手机号码")),
            chs_phone(chs_phone.message()),
          ],
          starttime: [required("请选择pk时间")],
          chip_type: [required("请选择pk方式")],
          chip: [required("请选择pk金额")],
        }).validate({ phone, starttime, chip, chip_type });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      try {
        let that = this,
          data = {
            id: that.id,
            phone: phone,
            uid: this.userPk.uid,
            starttime: starttime,
            endtime: endtime,
            chip_type: chip_type,
            chip: chip,
          };
        // postPk(data).then(function(res) {
        //   if (res.status == "400") {
        //     that.$dialog.toast({ mes: data.msg });
        //     return flase;
        //   }
        //   if (res.status == "200") {
        //     if (that.id) that.$dialog.toast({ mes: "修改成功" });
        //     else that.$dialog.toast({ mes: "发起成功" });
        //     that.$router.go(-1);
        //   }
        // });

        await postPk(data).then((res) => {
          //前边需要加await，才能处理返回错误提示
          if (res.status == "400") {
            that.$dialog.toast({ mes: data.msg });
          }
          if (res.status == "200") {
            if (that.id) that.$dialog.toast({ mes: "修改成功" });
            else that.$dialog.toast({ mes: "发起成功" });
            that.$router.push("/user/pk");
          }
        });
      } catch (e) {
        this.$dialog.error(e.msg);
      }
    },
    ChangeChinp: function() {
      this.userAddress.is_default = !this.userAddress.is_default;
    },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    loadAll() {
      let that = this;
      getUserPkUser().then((res) => {
        that.restaurants = res.data; //输入框选择
      });
    },
    handleSelect(item) {
      console.log(item);
    },
    handleIconClick(ev) {
      console.log(ev);
    },
  },
};
</script>
<style scoped>
.my-autocomplete li {
  line-height: normal;
  padding: 7px;
}
.name {
  text-overflow: ellipsis;
  overflow: hidden;
  line-height: 20px;
}
.addr {
  font-size: 12px;
  color: #b4b4b4;
  line-height: 20px;
  margin-top: -6px;
}

.highlighted .addr {
  color: #ddd;
}
</style>
